import { createFileRoute } from '@tanstack/react-router';
import { redirectIdeaManagementToIntake } from './-redirect';

export const Route = createFileRoute('/(app)/org/$org/idea-management/')({
  beforeLoad: redirectIdeaManagementToIntake,
});
